//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { updateStaffDepartmentFn } from 'api/org/dep';
import depTree from '@/components/dep-tree';
export default {
  components: {
    depTree: depTree
  },
  data: function data() {
    return {
      visible: false,
      disabled: false,
      dataForm: {
        department_id: '',
        department_name: '',
        staff_ids: []
      },
      dataRule: {
        department_id: [{
          required: true,
          message: this.$t('794')
        }]
      },
      popover: false
    };
  },
  methods: {
    init: function init(staffIds) {
      this.visible = true;
      this.dataForm.staff_ids = staffIds;
    },
    handleNodeClick: function handleNodeClick(val) {
      this.dataForm = Object.assign(this.dataForm, val);
      this.popover = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this.disabled = true;
          updateStaffDepartmentFn(_this.dataForm).then(function (res) {
            _this.disabled = false;
            if (res && res.code === 1) {
              _this.visible = false;
              _this.$parent.isDepAdjust && (_this.$parent.isDepAdjust = false);
              _this.$emit('refreshDataList');
              _this.$message({
                type: 'success',
                message: _this.$t('777')
              });
            }
          });
        }
      });
    }
  }
};